import ApplicationController from "application_controller.js";
import * as Turbo from "@hotwired/turbo";

export default class extends ApplicationController {

  debug = false;

  static values = {
    url: String,
    frame: String,
    interval: { type: Number, default: 60000 },
  };

  connect() {
    this.log_function("connect");

    this.startPolling();
  }

  disconnect() {
    this.log_function("disconnect");

    this.stopPolling();
  }

  startPolling() {
    this.log_function("startPolling");

    this.pollingTimer = setInterval(() => {
      this.poll();
    }, this.intervalValue);
  }

  stopPolling() {
    this.log_function("stopPolling");

    if (this.pollingTimer) {
      clearInterval(this.pollingTimer);
    }
  }

  poll() {
    this.log_function("poll");

    if (document.querySelector(".modal.show")) return; //* skip if modal is open

    //* Use Turbo.visit to perform the request and handle the response
    //* The { frame: ... } option tells Turbo to only update the element with this ID.
    //* The browser will automatically handle the ETag headers (If-None-Match) for us.
    Turbo.visit(this.urlValue, { frame: this.frameValue });
  }
}
